module.exports = __webpack_public_path__ + "static/media/bitdash-logo.23e1956d.svg";